export function openHelpArticle(articleId: string) {
  window.open(`/news/${articleId}`, "_blank");
}
